const modals = () => {
    
    const   catalog = document.querySelector('#catalog'),
            overflowCatalog = document.querySelector('.overflow'),
            catalogBlock = document.querySelector('.catalog'),
            dropdown = document.querySelectorAll('.dropdown__btn'),
            registerBtn = document.querySelector('#register'),
            modal = document.querySelector('.popup'),
            join = document.querySelector('#join'),
            loginBtn = document.querySelector('#login'),
            overflow = document.querySelector('.overflow_top0'),
            helpBtn = document.querySelectorAll('#help');

    let executive = false;


    const scroll = calcScroll();

    function calcScroll() {
        let div = document.createElement('div');
        div.style.width = '50px';
        div.style.height = '50px';
        div.style.overflowY = 'scroll';
        div.style.visibility = 'hidden';

        document.body.appendChild(div);
        let scrollWidth = div.offsetWidth - div.clientWidth;
        div.remove();
        return scrollWidth;
    }
    
    function hideCatalog() {
        overflowCatalog.style.cssText = `
        visibility: hidden;
        opacity: 0;
        display: none;
        `;
        document.body.style.marginRight = 0;
        document.body.style.overflow = 'visible';
        catalogBlock.style.animationName = 'hideUp';
        catalogBlock.style.display = 'none';
        return executive = false;
    }

    catalog.addEventListener('click', (e)=> {

        if(document.documentElement.clientWidth > 768) {
            e.preventDefault();
            if(!executive) {
                overflowCatalog.style.cssText = `
                    visibility: visible;
                    opacity: 1;
                `;
                catalogBlock.style.animationName = 'showDown';
                catalogBlock.style.display = 'block';
                document.body.style.overflow = 'hidden';
                document.body.style.marginRight = `${scroll}px`;
                return executive = true;
            } else if(executive) {
                hideCatalog();
                
            }
        }
    })
    overflowCatalog.addEventListener('click', (e)=> {
        if(e.target.classList.contains('overflow')) {
            hideCatalog();

        }
    })
    document.addEventListener('keydown', (e) => {
        if(e.key === 'Escape') {
            hideCatalog();
            hideModal();

        }
    })

    document.addEventListener('click', (e) => {
        if(!e.target.classList.contains('dropdown__btn') && !e.target.classList.contains('dropdown__menu')) {
            dropdown.forEach(btn => {
                btn.nextElementSibling.classList.remove('show');
                btn.classList.remove('rotate');
            })
        }
    })


    dropdown.forEach(btn => {
        btn.addEventListener('click', () => {
            btn.nextElementSibling.classList.toggle('show');
            btn.classList.toggle('rotate');

        })
    })
    function hideModal() {
        overflow.style.cssText = `
            visibility: hidden;
            opacity: 0;
        `;
        document.body.style.marginRight = 0;
        document.body.style.overflow = 'visible';
        overflow.children.forEach(item => {item.style.opacity = '0'; item.style.visibility = 'hidden'});
        return executive = false;

    }
    
    registerBtn.addEventListener('click', (e) => {
        e.preventDefault();
        hideCatalog();
        overflow.style.cssText = `
            visibility: visible;
            opacity: 1;
        `;
        overflow.children.forEach(item => {item.style.opacity = '0'; item.style.visibility = 'hidden'});
        modal.style.opacity = '1';
        modal.style.visibility = 'visible';
        modal.children[0].style.display = 'none';
        modal.children[1].style.display = 'block';
        document.body.style.overflow = 'hidden';
        document.body.style.marginRight = `${scroll}px`;
        return executive = true;
    })
    overflow.addEventListener('click', (e) => {
        if(e.target.classList.contains('overflow')) {
            hideModal();
        }
    })

    loginBtn.addEventListener('click', e => {
        e.preventDefault();
        modal.children[1].style.display = 'none';
        modal.children[0].style.display = 'block';
    })

    join.addEventListener('click', e => {
        e.preventDefault();
        modal.children[0].style.display = 'none';
        modal.children[1].style.display = 'block';
    })



    const items = document.querySelectorAll('.item'),
          preview = document.querySelector('.preview'),
          previewClose = document.querySelector('.product-descr__close');

    if(preview) {
        items.forEach(item => {
            const eye = item.querySelector('.product-eye');
            eye.addEventListener('click', (e) => {
                e.preventDefault();
                overflow.children.forEach(item => {item.style.opacity = '0'; item.style.visibility = 'hidden'});
                preview.style.opacity = '1';
                preview.style.visibility = 'visible';
                overflow.style.cssText = `
                    visibility: visible;
                    opacity: 1;
                `;
                document.body.style.overflow = 'hidden';
                document.body.style.marginRight = `${scroll}px`;
    
            })
        })
        previewClose.addEventListener('click', () => {
            document.body.style.overflow = 'visible';
            document.body.style.marginRight = 0;
            overflow.style.cssText = `
                    visibility: hidden;
                    opacity: 0;
            `;
            overflow.children.forEach(item => {item.style.opacity = '0'; item.style.visibility = 'hidden'});
    
        })
    
        const orderBtns = document.querySelectorAll('#toCard'),
              addedModal = document.querySelector('.added'),
              amountClose = document.querySelector('.close');          
        orderBtns.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                overflow.children.forEach(item => {item.style.opacity = '0'; item.style.visibility = 'hidden'});
                addedModal.style.opacity = '1';
                addedModal.style.visibility = 'visible';
                overflow.style.cssText = `
                    visibility: visible;
                    opacity: 1;
                `;
                document.body.style.overflow = 'hidden';
                document.body.style.marginRight = `${scroll}px`;
            })
        })
        amountClose.addEventListener('click', () => {
            document.body.style.overflow = 'visible';
            document.body.style.marginRight = 0;
            overflow.style.cssText = `
                    visibility: hidden;
                    opacity: 0;
            `;
            overflow.children.forEach(item => {item.style.opacity = '0'; item.style.visibility = 'hidden'});
        })
    }
    if(helpBtn) {
        const helpForm = document.querySelector('.help'),
              closeHelp = document.querySelector('.help__close');
        helpBtn.forEach(i => {
            i.addEventListener('click', (e) => {
                e.preventDefault();
                overflow.children.forEach(item => {item.style.opacity = '0'; item.style.visibility = 'hidden'});
                helpForm.style.opacity = '1';
                helpForm.style.visibility = 'visible';
                overflow.style.cssText = `
                    visibility: visible;
                    opacity: 1;
                `;
                document.body.style.overflow = 'hidden';
                document.body.style.marginRight = `${scroll}px`;
            })
        })
        closeHelp.addEventListener('click', () => {
            document.body.style.overflow = 'visible';
            document.body.style.marginRight = 0;
            overflow.style.cssText = `
                    visibility: hidden;
                    opacity: 0;
            `;
            overflow.children.forEach(item => {item.style.opacity = '0'; item.style.visibility = 'hidden'});
        })
    }

}

export default modals;